import React from 'react';
import Header from './Header';

/**
 * 매쓰피드 이용약관
 */
function Terms() {
  return (
    <div className="layout-def layout-lc terms">
      <Header title="이용약관" />
      <div className="container">
        <div className="inner">
          <div className="w800">
            <section>
              <h2>제 1 장 환영합니다!</h2>
              <div className="terms_cont">
                <h3>제 1 조 (목적)</h3>
                <div className="paragraph">
                  주식회사 웅진씽크빅(이하 ‘회사’)가 제공하는 서비스를 이용해
                  주셔서 감사합니다. 이 이용약관은 주식회사 웅진씽크빅이
                  운영하는 AI연산에서 제공하는 인터넷 관련 서비스(이하
                  ‘서비스’)를 이용함에 있어 이용조건 및 절차와 이용자의 권리와
                  의무 및 책임사항을 규정함을 목적으로 합니다.
                </div>
              </div>
              <div className="terms_cont">
                <h3>제 2 조 (약관의 효력 및 변경)</h3>
                <div className="paragraph">
                  <ul>
                    <li>
                      <span>①</span>이 약관은 서비스내의 게시판을 통하여
                      공지함으로써 효력을 발생하며, 회사는 이 약관의 내용과
                      상호, 영업소 소재지, 대표자의 성명, 사업자등록번호,
                      연락처(전화, 팩스, 전자우편 주소 등) 등을 이용자가 알 수
                      있도록 회사의 초기 서비스화면(전면)에 게시합니다.
                    </li>
                    <li>
                      <span>②</span>회사는 “약관의규제에관한법률”,
                      “정보통신망이용촉진등에관한법률(이하‘정보통신망이용촉진법’)”,
                      “방문판매등에 관한법률”, “소비자보호법” 등 관련법을
                      위배하지 않는 범위에서 임의로 이 약관을 개정할 수
                      있습니다.
                    </li>
                    <li>
                      <span>③</span>회사가 약관을 개정할 경우에는 적용 일자 및
                      개정 사유를 명시하여 현행 약관과 함께 본 사이트의
                      초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지
                      공지합니다.
                    </li>
                    <li>
                      <span>④</span>회원은 변경된 약관에 동의하지 않을 경우 회원
                      탈퇴를 요청할 수 있으며, 변경된 약관의 효력 발생일로부터
                      7일 이후에도 거부의사를 표시하지 아니하고 서비스를 계속
                      사용할 경우 약관의 변경 사항에 동의한 것으로 간주됩니다.
                    </li>
                    <li>
                      <span>⑤</span>변경된 약관에 대한 정보를 알지 못해 발생하는
                      회원의 피해는 회사에서 책임지지 않습니다.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="terms_cont">
                <h3>제 3 조 (약관 외 내용)</h3>
                <div className="paragraph">
                  이 약관은 회사가 제공하는 개인정보 보호정책과 함께 적용하며,
                  이 약관에서 규정하지 않은 사항에 대해서는 전자거래
                  소비자보호지침 및 관계법령 또는 상관례에 따릅니다.
                </div>
              </div>
              <div className="terms_cont">
                <h3>제 4 조 (용어의 정의)</h3>
                <div className="paragraph">
                  <ul>
                    <li>
                      <span>①</span>이 약관에서 사용하는 용어의 정의는 다음과
                      같습니다.
                      <ul>
                        <li>
                          <span>1.</span>‘이용자’란 “홈페이지”에 접속하여 이
                          약관에 따라 회사가 제공하는 서비스를 받는 준회원,
                          정회원 및 비회원을 말합니다.
                        </li>
                        <li>
                          <span>2.</span>‘준회원’이라 함은 회사에 개인정보를
                          제공하여 회원가입을 한 자로서, 회사의 정보를
                          지속적으로 제공받으며, 회사가 제공하는 서비스를
                          계속적으로 이용할 수 있는 자를 말합니다.{" "}
                        </li>
                        <li>
                          <span>3.</span>‘정회원’이라 함은 회사에 개인정보를
                          제공하여 회원가입을 한 자로서, 회원인증 절차를 통해
                          홈스쿨 제품(브이스터디, V2 수학, 논술 등) 구매한
                          회원임을 증명 받은 자를 말합니다.
                        </li>
                        <li>
                          <span>4.</span>여기서, ‘회원인증’이라 함은 홈스쿨
                          제품을 학습하고 있는 회원이 제품 구매계약 당시에
                          회사에 제공한 개인정보와 회사에서 부여한 임의의 키
                          값을 이용하여 홈스쿨 회원임을 증명하는 절차입니다.
                          홈스쿨 회원으로 인증되면 회원에게만 제공되는 특정
                          서비스의 이용권한을 부여 받게 됩니다.
                        </li>
                        <li>
                          <span>5.</span>‘비회원’이라 함은 회원에 가입하지 않고
                          회사가 제공하는 서비스를 이용하는 자를 말합니다.
                          ‘아이디(ID)’라 함은 이용자가 서비스를 이용하고, 회사가
                          회원을 구분, 식별할 수 있도록 이용자가 선정하고 회사가
                          부여하는 문자와 숫자의 조합을 말합니다.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
            <section>
              <h2>제 1 장 환영합니다!</h2>
              <div className="terms_cont">
                <h3>제 1 조 (목적)</h3>
                <div className="paragraph">
                  주식회사 웅진씽크빅(이하 ‘회사’)가 제공하는 서비스를 이용해
                  주셔서 감사합니다. 이 이용약관은 주식회사 웅진씽크빅이
                  운영하는 AI연산에서 제공하는 인터넷 관련 서비스(이하
                  ‘서비스’)를 이용함에 있어 이용조건 및 절차와 이용자의 권리와
                  의무 및 책임사항을 규정함을 목적으로 합니다.
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;